module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo"
  }, [(_vm.$i18n.locale == 'se') ? _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-se.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("img/kunniakierros-logo-fi.png")
    }
  })]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.store.page.title))]), _vm._v(" "), _vm._l((_vm.description.split('\n')), function(paragraph, i) {
    return _c('p', {
      key: i,
      staticClass: "about"
    }, [_vm._v("\r\n        " + _vm._s(paragraph)), _c('br')])
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "button button-green"
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("startView.login")) + "\r\n        ")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-992056a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/AboutKKView.vue
// module id = 126
// module chunks = 0